import script from "./TextReader.vue?vue&type=script&setup=true&lang=js"
export * from "./TextReader.vue?vue&type=script&setup=true&lang=js"

import "./TextReader.vue?vue&type=style&index=0&id=49b3d402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b3d402"]])

export default __exports__